module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('y-shelf', {
    attrs: {
      "title": _vm.orderTitle
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(_vm.orderList.length) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "min-height": "10vw"
    },
    attrs: {
      "element-loading-text": "加载中..."
    }
  }, [(_vm.orderStatus !== -1 && _vm.orderStatus !== 6) ? _c('div', {
    staticClass: "orderStatus"
  }, [_c('el-steps', {
    attrs: {
      "space": 200,
      "active": _vm.orderStatus
    }
  }, [_c('el-step', {
    attrs: {
      "title": "下单",
      "description": _vm.createTime
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "付款",
      "description": _vm.payTime
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "配货",
      "description": ""
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "出库",
      "description": ""
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "交易成功",
      "description": _vm.finishTime
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.orderStatus === -1) ? _c('div', {
    staticClass: "orderStatus-close"
  }, [_c('el-steps', {
    attrs: {
      "space": 780,
      "active": 2
    }
  }, [_c('el-step', {
    attrs: {
      "title": "下单",
      "description": _vm.createTime
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "交易关闭",
      "description": _vm.closeTime
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.orderStatus === 6) ? _c('div', {
    staticClass: "orderStatus-close"
  }, [_c('el-steps', {
    attrs: {
      "space": 780,
      "active": 2
    }
  }, [_c('el-step', {
    attrs: {
      "title": "下单",
      "description": _vm.createTime
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "交易关闭",
      "description": _vm.closeTime
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.orderStatus === 1) ? _c('div', {
    staticClass: "status-now"
  }, [_c('ul', [_c('li', {
    staticClass: "status-title"
  }, [_c('h3', [_vm._v("订单状态：待付款")])]), _vm._v(" "), _c('li', {
    staticClass: "button"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.orderPayment(_vm.orderId)
      }
    }
  }, [_vm._v("现在付款")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm._cancelOrder()
      }
    }
  }, [_vm._v("取消订单")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "realtime"
  }, [_c('span', [_vm._v("您的付款时间还有 ")]), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_c('countDown', {
    attrs: {
      "endTime": _vm.countTime,
      "endText": "已结束"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("，超时后订单将自动取消。")])])]) : _vm._e(), _vm._v(" "), (_vm.orderStatus === 2) ? _c('div', {
    staticClass: "status-now"
  }, [_c('ul', [_c('li', {
    staticClass: "status-title"
  }, [_c('h3', [_vm._v("订单状态：已支付，待系统审核确认")])])]), _vm._v(" "), _c('p', {
    staticClass: "realtime"
  }, [_c('span', [_vm._v("请耐心等待审核，审核结果将发送到您的邮箱，并且您所填写的捐赠数据将显示在捐赠表中。")])])]) : _vm._e(), _vm._v(" "), (_vm.orderStatus === -1 || _vm.orderStatus === 6) ? _c('div', {
    staticClass: "status-now"
  }, [_c('ul', [_c('li', {
    staticClass: "status-title"
  }, [_c('h3', [_vm._v("订单状态：已关闭")])])]), _vm._v(" "), _c('p', {
    staticClass: "realtime"
  }, [_c('span', [_vm._v("您的订单已关闭。")])])]) : _vm._e(), _vm._v(" "), (_vm.orderStatus === 5) ? _c('div', {
    staticClass: "status-now"
  }, [_c('ul', [_c('li', {
    staticClass: "status-title"
  }, [_c('h3', [_vm._v("订单状态：已完成")])])]), _vm._v(" "), _c('p', {
    staticClass: "realtime"
  }, [_c('span', [_vm._v("您的订单已交易成功，感谢您的惠顾！")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "gray-sub-title cart-title"
  }, [_c('div', {
    staticClass: "first"
  }, [_c('div', [_c('span', {
    staticClass: "order-id"
  }, [_vm._v("商品名称")])]), _vm._v(" "), _c('div', {
    staticClass: "f-bc"
  }, [_c('span', {
    staticClass: "price"
  }, [_vm._v("单价")]), _vm._v(" "), _c('span', {
    staticClass: "num"
  }, [_vm._v("数量")]), _vm._v(" "), _c('span', {
    staticClass: "operation"
  }, [_vm._v("小计")])])])]), _vm._v(" "), _c('div', {
    staticClass: "goods-table"
  }, _vm._l((_vm.orderList), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "cart-items"
    }, [_c('a', {
      staticClass: "img-box",
      on: {
        "click": function($event) {
          return _vm.goodsDetails(item.productId)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.productImg,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "name-cell ellipsis"
    }, [_c('a', {
      attrs: {
        "title": "",
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.goodsDetails(item.productId)
        }
      }
    }, [_vm._v(_vm._s(item.productName))])]), _vm._v(" "), _c('div', {
      staticClass: "n-b"
    }, [_c('div', {
      staticClass: "price"
    }, [_vm._v("¥ " + _vm._s(Number(item.salePrice).toFixed(2)))]), _vm._v(" "), _c('div', {
      staticClass: "goods-num"
    }, [_vm._v(_vm._s(item.productNum))]), _vm._v(" "), _c('div', {
      staticClass: "subtotal"
    }, [_vm._v(" ¥ " + _vm._s(Number(item.salePrice * item.productNum).toFixed(2)))])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "order-discount-line"
  }, [_c('p', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bolder"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-right": "47px"
    }
  }, [_vm._v("商品总计：")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "500",
      "line-height": "32px"
    }
  }, [_vm._v("¥ " + _vm._s(_vm.orderTotal))])]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "padding-right": "30px"
    }
  }, [_vm._v("运费：")]), _c('span', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v("+ ¥ 0.00")])]), _vm._v(" "), _c('p', {
    staticClass: "price-total"
  }, [_c('span', [_vm._v("应付金额：")]), _c('span', {
    staticClass: "price-red"
  }, [_vm._v("¥ " + _vm._s(_vm.orderTotal))])])]), _vm._v(" "), _c('div', {
    staticClass: "gray-sub-title cart-title"
  }, [_c('div', {
    staticClass: "first"
  }, [_c('div', [_c('span', {
    staticClass: "order-id"
  }, [_vm._v("收货信息")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "155px",
      "padding": "20px 30px"
    }
  }, [_c('p', {
    staticClass: "address"
  }, [_vm._v("姓名：" + _vm._s(_vm.userName))]), _vm._v(" "), _c('p', {
    staticClass: "address"
  }, [_vm._v("联系电话：" + _vm._s(_vm.tel))]), _vm._v(" "), _c('p', {
    staticClass: "address"
  }, [_vm._v("详细地址：" + _vm._s(_vm.streetName))])])]) : _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "加载中..."
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "100px 0",
      "text-align": "center"
    }
  }, [_vm._v("\n          获取该订单信息失败\n        ")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b17346f","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/User/children/orderDetail.vue
// module id = 622
// module chunks = 0